import { Navigate, Route, Routes, useLocation } from "react-router-dom"
import Mapa from "./components/Mapa"
import Sujeto from "./components/Sujeto"
import background from './assets/banner-catalogo-total-2023-a.png'
import { About } from "./components/About"
import { Porcentaje } from "./components/Porcentaje"
// import logo from './assets/logo-catalogo-2023.png'
// import personajes from './assets/personajes.png'

const NavBarCatalogo = () => {

  return (
    <nav id="nav" className="navbar navbar-expand-md navbar-light p-0 m-0" 
      style={{ backgroundImage: `url(${background})`, 
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%',
        backgroundPosition: 'cover',
        height: '415px'
      }}>
    </nav>
  );
}

const NavBarPorcentaje = () => {
  return (
    <nav className="navbar navbar-expand-md navbar-light mb-xs-3 mb-sm-5 p-2">
      <img 
        src={require('./assets/logo-catalogo-2023.png')} style={{ width: '200px'}} alt="Logo catálgo 2023"
      />
    </nav>
  );
}

const App = () => {
  const location = useLocation();
  let containercss = location.pathname === '/catalogo-de-politicas-publicas/porcentaje-minimo-de-participacion-ciudadana' ? 'container-fluid' : 'container';
  containercss+=' mb-5';
  // console.log(location.pathname);
  return (
    <>
      {  
        location.pathname === '/catalogo-de-politicas-publicas/porcentaje-minimo-de-participacion-ciudadana' 
          ? <NavBarPorcentaje />
          : <NavBarCatalogo />
      }
      
      <div id="main" className={containercss}>
        <Routes>
          <Route path={`${process.env.PUBLIC_URL}/`} element={<Mapa />} />
          
          <Route path={`${process.env.PUBLIC_URL}/:id`} element={<Sujeto />} />
          <Route path={`${process.env.PUBLIC_URL}/como-solicito-un-plebiscito`} element={<About />} />
          <Route path={`${process.env.PUBLIC_URL}/porcentaje-minimo-de-participacion-ciudadana`} element={<Porcentaje />} />
          <Route path={`${process.env.PUBLIC_URL}/*`} element={<Navigate to="/" />} />
        </Routes>
      </div>
    </>
  )
}

export default App